<div #transferOwnershipModal class="modal fade" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content border-radius-0">
      <div class="modal-header text-uppercase py-2 font-size-16">
        <div class="modal-title" i18n="@@app.transfer_ownership">Transfer ownership</div>
        <button type="button" class="close" (click)="closeModal()">&times;</button>
      </div>
      <div class="modal-body">
        @if (project?.projectMembers?.length > 0) {
          <div class="row">
            <div class="col-12">
              <p>
                <ng-container><b i18n="@@app.members">Members</b>  (<b>{{ project?.projectMembers?.length }}</b>)</ng-container>
              </p>
            </div>
          </div>
        }
        @if (project?.projectMembers?.length > 0) {
          <div class="row">
            <div class="col-12">
              <div class="bg-blue-gray overflow-y-auto overflow-x-hidden members-area">
                <!-- repeat -->
                @for (member of (project?.projectMembers | removeInactiveUsers); track member) {
                  <div class="px-3 py-2 d-flex align-items-center justify-content-between">
                    <div class="flex-auto">
                      <div class="d-flex align-items-center">
                        <img src="{{member?.avatar}}" alt="" [title]="member?.firstName + ' ' + member?.lastName" width="28px" height="28px"
                          class="cursor-pointer rounded-circle mr-1"/>
                          <img class="cursor-pointer mr-2 viewer-editor-icon" alt="" [title]="member?.firstName + ' ' + member?.lastName" [src]="member?.canEditProject ? roleIcons.EDITOR_ICON : roleIcons.VIEWER_ICON">
                          <div>
                            <div class="font-size-11 font-weight-semibold word-break-all">{{member?.firstName}} {{member?.lastName}}</div>
                            <div class="font-size-11 color-se-gray word-break-all">{{member?.email}}</div>
                          </div>
                        </div>
                      </div>
                      <div class="display-flex justify-content-end flex-width-50">
                        @if (user?.email === project?.projectOwner.email) {
                          <button type="button"
                            class="btn btn-sm border-rounded py-2 pl-2 mx-0 pr-2 d-flex align-items-center white-bg"
                            (click)="onTransferOwnership(member)">
                            <img alt="" src="/assets/images/transfer_icon.svg">
                            <span class="text-uppercase ml-2" i18n="@@app.transfer_ownership">Transfer ownership</span>
                          </button>
                        }
                      </div>
                    </div>
                  }
                  <!-- end repeat -->
                </div>
              </div>
            </div>
          }
        </div>
        <div class="modal-footer pt-1 border-0">
        </div>
      </div>
    </div>
  </div>
